<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive
      code="adresse_correspondance"
      :items="
        sas.adressesProfessionnelles
          .concat([sas.adressePersonnelle])
          .map(getTextSasAdresseDropdown)
      "
      v-model="sas.sasInscriptionTableau.adresseDeCorrespondanceRenouvellement"
      :live="{ endpoint: 'sas-inscription-tableau', cle: 7717, fileId: sas.sasInscriptionTableau.id }"
    />
    <Consentements :sas="sas" />
  </v-form>
</template>

<script>
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import RelationSasAdresse from "@/mixins/RelationSasAdresse"
import Consentements from "@/components/form_parts/Consentements"

export default {
  mixins: [CataloguesHelpers, StepFormWithValidation, RelationSasAdresse],
  components: { Consentements },
  props: {
    sas: { type: Object }
  },
  computed: {
    sasInscriptionTableau() {
      return this.sas.sasInscriptionTableau
    }
  },
  methods: {
    liveSasInscriptionTableau(cle) {
      return { endpoint: "sas-inscription-tableau", cle: cle, fileId: this.sasInscriptionTableau.id }
    }
  }
}
</script>

<style></style>